export const LOGGING_CONFIG = 'LOGGING_CONFIG';
export const LOGGING_PROVIDERS = 'LOGGING_PROVIDERS';
